import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import { format } from "date-fns";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { outreachViewModal } from "DashboardOutreachAction";
import {
  BASE_IMAGES_URL,
  ACCESS_FILES_API_KEY,
  DATE_FORMAT_WITH_TIME_FNS,
  validateUrl,
} from "Constants";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import LocaleStrings from "Languages";

ChartJS.register(ArcElement, Tooltip, Legend);

class DashboardOutreachView extends Component {
  constructor(props) {
    super(props);
  }

  close = () => {
    this.props.outreachViewModal({ show: false });
  };

  render() {
    var { DashboardNotificationViewModal } = this.props;
    //console.log("values :- ", DashboardNotificationViewModal.values);
    let details =
      DashboardNotificationViewModal.values &&
      DashboardNotificationViewModal.values.notification_details
        ? JSON.parse(DashboardNotificationViewModal.values.notification_details)
        : {};
    //console.log("details :- ", details);

    let iosCount = 0;
    let androidCount = 0;

    let deliveredCount = details.successful ? details.successful : 0;
    let failedCount = details.failed ? details.failed : 0;
    let errorCount = details.errored ? details.errored : 0;
    let remCount = details.remaining ? details.remaining : 0;

    let totalSentCount =
      parseInt(deliveredCount) +
      parseInt(failedCount) +
      parseInt(errorCount) +
      parseInt(remCount);

    if (
      details.platform_delivery_stats &&
      details.platform_delivery_stats.ios &&
      details.platform_delivery_stats.ios.successful
    ) {
      iosCount = details.platform_delivery_stats.ios.successful;
    }

    if (
      details.platform_delivery_stats &&
      details.platform_delivery_stats.android &&
      details.platform_delivery_stats.android.successful
    ) {
      androidCount = details.platform_delivery_stats.android.successful;
    }
    let totalPlatformCount = parseInt(androidCount) + parseInt(iosCount);
    const deliveryData = {
      labels: [
        "Delivered",
        "Failed (Unsubscribed)",
        "Failed (Errored)",
        "Remaining",
      ],
      datasets: [
        {
          label: "# ",
          data: [deliveredCount, failedCount, errorCount, remCount],
          backgroundColor: [
            "rgba(84, 207, 141,1)",
            "rgba(229, 75, 77, 1)",
            "rgba(255, 206, 86, 0.2)",
            "rgba(75, 192, 192, 0.2)",
          ],
          borderColor: [
            "rgba(75, 192, 192, 1)",
            "rgba(255, 99, 132, 1)",
            "rgba(255, 99, 132, 1)",
            "rgba(255, 206, 86, 1)",
          ],
          borderWidth: 1,
        },
      ],
    };

    const platformData = {
      labels: ["iOS", "Android"],
      datasets: [
        {
          label: "# ",
          data: [iosCount, androidCount],
          backgroundColor: ["rgba(129,131,236,1)", "rgba(58,61,179,1)"],
          borderColor: ["rgba(153, 102, 255, 1)", "rgba(255, 159, 64, 1)"],
          borderWidth: 1,
        },
      ],
    };

    return (
      <div>
        <Modal
          className="modal-container"
          show={DashboardNotificationViewModal.show ? true : false}
          onHide={this.close}
          animation={true}
          keyboard={false}
          backdrop="static"
          dialogClassName="modal-xl"
        >
          <Modal.Header>
            <div className="import-modal-title">
              {LocaleStrings.outreach_view_push_notification_title}
            </div>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={() => this.close()}
            >
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex">
              {DashboardNotificationViewModal.values.image ? (
                <div className="mr-20" style={{ width: 230, height: 230 }}>
                  <img
                    className="b-radius-10"
                    src={`${BASE_IMAGES_URL}/${DashboardNotificationViewModal.values.image}?api_key=${ACCESS_FILES_API_KEY}`}
                    alt="Push Image"
                    style={{ width: 230, height: 230 }}
                  />
                </div>
              ) : (
                ""
              )}
              <div>
                <div className="mb-15">
                  <div className="custom-text1-primary-normal">
                    {LocaleStrings.outreach_form_label_title}
                  </div>
                  <div className="custom-text1-primary-bold">
                    {DashboardNotificationViewModal.values.title}
                  </div>
                </div>
                <div className="">
                  <div className="custom-text1-primary-normal">
                    {LocaleStrings.outreach_form_label_content}
                  </div>
                  <div className="custom-text1-primary-bold">
                    {DashboardNotificationViewModal.values.notificationtext}
                  </div>
                </div>
              </div>
            </div>
            {DashboardNotificationViewModal.values.redirectto ? (
              <div className="mt-15">
                <div className="custom-text1-primary-normal">
                  {LocaleStrings.outreach_table_list_linked_with}
                </div>
                <div className="vertical-align-center">
                  <div className="custom-text1-primary-bold text-capitalize">
                    {DashboardNotificationViewModal.values.redirectto}
                  </div>
                  {DashboardNotificationViewModal.values.redirectto ===
                  "external" ? (
                    <a
                      target="_blank"
                      href={
                        DashboardNotificationViewModal.values.internallinkedwith
                      }
                      className="ml-10 pointer"
                    >
                      {DashboardNotificationViewModal.values.internallinkedwith}
                    </a>
                  ) : (
                    <div className="custom-text1-primary-bold">
                      <span className="ml-10">-</span>
                      <span className="ml-10">
                        {
                          DashboardNotificationViewModal.values
                            .internallinkedwith
                        }
                      </span>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              ""
            )}

            {details.hasOwnProperty("successful") ? (
              <div
                className="vertical-align-center-justify-between mt-20"
                style={{ gap: 16 }}
              >
                <div className="jWsjJg">
                  <div class="sc-lqUcu fqZrsk">
                    <h1>Delivery Statistics</h1>
                  </div>
                  <div className="vertical-align-center-justify-between">
                    <div>
                      <table class="sc-lcuqYl bHtaYw table">
                        <tbody>
                          <tr class="sc-iyIzpG jDnIqX">
                            <td class="sc-cnOmFn iSMRTY">Total Sent</td>
                            <td class="sc-bYXICO TEauH">{totalSentCount}</td>
                          </tr>
                          <tr class="sc-iyIzpG jDnIqX">
                            <td class="sc-cnOmFn iSMRTY">Delivered</td>
                            <td class="sc-bYXICO TEauH">{deliveredCount}</td>
                          </tr>
                          <tr class="sc-iyIzpG jDnIqX">
                            <td class="sc-cnOmFn iSMRTY">
                              Failed (Unsubscribed)
                            </td>
                            <td class="sc-bYXICO TEauH">{failedCount}</td>
                          </tr>
                          <tr class="sc-iyIzpG jDnIqX">
                            <td class="sc-cnOmFn iSMRTY">Failed (Errored)</td>
                            <td class="sc-bYXICO TEauH">{errorCount}</td>
                          </tr>
                          <tr class="sc-iyIzpG jDnIqX">
                            <td class="sc-cnOmFn iSMRTY">Remaining</td>
                            <td class="sc-bYXICO TEauH">{remCount}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div>
                      <Pie data={deliveryData} />
                    </div>
                  </div>
                </div>

                <div className="jWsjJg">
                  <div class="sc-lqUcu fqZrsk">
                    <h1>Platform Statistics</h1>
                  </div>
                  <div className="vertical-align-center-justify-between">
                    <div>
                      <table class="sc-lcuqYl bHtaYw table">
                        <tbody>
                          <tr class="sc-iyIzpG jDnIqX">
                            <td class="sc-cnOmFn iSMRTY">Total Delivered</td>
                            <td class="sc-bYXICO TEauH">
                              {totalPlatformCount}
                            </td>
                          </tr>
                          <tr class="sc-iyIzpG jDnIqX">
                            <td class="sc-cnOmFn iSMRTY">iOS</td>
                            <td class="sc-bYXICO TEauH">{iosCount}</td>
                          </tr>
                          <tr class="sc-iyIzpG jDnIqX">
                            <td class="sc-cnOmFn iSMRTY">Google Android</td>
                            <td class="sc-bYXICO TEauH">{androidCount}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div>
                      <Pie data={platformData} />
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="mt-20 event-expired">
                {LocaleStrings.outreach_no_data_found}
              </div>
            )}
          </Modal.Body>
          {/* <Modal.Footer>
            <Button
              type="button"
              className="btn btn-custom-white"
              onClick={this.close}
            >
              {LocaleStrings.button_close}
            </Button>
          </Modal.Footer> */}
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    DashboardNotificationViewModal: state.DashboardNotificationViewModal,
  };
}

export default connect(mapStateToProps, {
  outreachViewModal,
})(DashboardOutreachView);
